import axios from "../utils/axios";
import { buildFilterQueryString, buildSortingParams } from "../utils/query";

export const getCelebrations = async ({ offset, limit, filters, sortModel } = {}) => {
  const filterQueryString = buildFilterQueryString(filters);
  const sortingParams = buildSortingParams(sortModel);
  const queryParts = [limit != null && `limit=${limit}`, offset != null && `offset=${offset}`, filterQueryString, sortingParams].filter(Boolean);
  const url = `/celebrations?${queryParts.join("&")}`;
  const { data: celebrations } = await axios.get(url);
  return celebrations;
};

export const removeCelebration = async (celebrationId) => {
  const { data: removedCelebration } = await axios.delete(`/celebrations/${celebrationId}`);
  return removedCelebration;
};

export const addCelebration = async (celebration) => {
  const { data: addedCelebration } = await axios.post(`/celebrations`, {
    data: celebration,
  });
  return addedCelebration;
};

export const updateCelebration = async ({ id, ...celebrationData }) => {
  const { data: updatedCelebration } = await axios.put(`/celebrations/${id}`, {
    data: celebrationData,
  });
  return updatedCelebration;
};
